/**
 * Mixpanel is loaded from `public/index.html` (stub + async SDK). Token + debug come from env at build time.
 */
const TOKEN_NONPROD = "28266d26bcbfc7c2509201cb76e9660c";

const resolveToken = (): string | null => {
  const fromEnv = process.env.REACT_APP_MIXPANEL_TOKEN?.trim();
  if (fromEnv) return fromEnv;
  if (process.env.NODE_ENV !== "production") return TOKEN_NONPROD;
  console.warn(
    "[Mixpanel] REACT_APP_MIXPANEL_TOKEN is unset for this production build. Mixpanel will not initialize."
  );
  return null;
};

const resolveDebug = (): boolean => {
  if (process.env.REACT_APP_MIXPANEL_DEBUG === "true") return true;
  if (process.env.REACT_APP_MIXPANEL_DEBUG === "false") return false;
  return process.env.NODE_ENV === "development";
};

export const initMixpanel = (): void => {
  if (typeof window === "undefined") return;
  const mixpanel = (window as unknown as { mixpanel?: { init?: (token: string, opts?: Record<string, unknown>) => void } }).mixpanel;
  if (!mixpanel?.init) return;
  const w = window as Window & { __mixpanelInitialized?: boolean };
  if (w.__mixpanelInitialized) return;

  const token = resolveToken();
  if (!token) return;

  mixpanel.init(token, {
    debug: resolveDebug(),
  });
  w.__mixpanelInitialized = true;
};
